import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { get, MICROSERVICES } from 'api';
import { IPolicy, IPopulatedPolicy } from 'interfaces/Policy';
import {
  IMyKnownError,
  REQUEST_LIFE_CICLE,
  IListRequestParams,
} from 'interfaces/requests';
import { openAlertToUserLogoutAction } from 'modules/user';

import endpoints from './endpoints';
import { IPolicyListState } from './interfaces';

export const listPoliciesAction = createAsyncThunk<
  IPolicy[],
  IListRequestParams,
  { rejectValue: IMyKnownError }
>('listPolicies', async (payload, { dispatch, rejectWithValue }) => {
  try {
    const result = await get<IPopulatedPolicy[]>(MICROSERVICES.AUTH, {
      url: endpoints.listPolicies(),
      params: payload,
    });
    return result.data.map((value) => ({
      ...value,
      permissions: value.permissions.map((permission) => ({
        resource: permission.resource._id,
        operations: permission.operations.map((operation) => operation._id),
      })),
    }));
  } catch (error) {
    dispatch(openAlertToUserLogoutAction());
    return rejectWithValue(error);
  }
});

const initialState: IPolicyListState = {
  loading: REQUEST_LIFE_CICLE.IDLE,
  errorMessage: '',
  list: [],
};

const policyListSlice = createSlice({
  name: 'policyList',
  initialState,
  reducers: {
    clearPolicyListAction: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(listPoliciesAction.fulfilled, (state, action) => {
      state.loading = REQUEST_LIFE_CICLE.SUCCEEDED;
      state.errorMessage = '';
      state.list = action.payload;
    });
    builder.addCase(listPoliciesAction.pending, (state) => {
      state.loading = REQUEST_LIFE_CICLE.PENDING;
    });
    builder.addCase(listPoliciesAction.rejected, (state, action) => {
      state.loading = REQUEST_LIFE_CICLE.FAILED;
      state.errorMessage = action.payload?.message || 'Erro no servidor';
    });
  },
});

const { reducer, actions } = policyListSlice;
export const { clearPolicyListAction } = actions;
export default reducer;
